import { FormHelperText, type FormHelperTextProps } from '@chakra-ui/react';

export type UiFormHelperTextProps = FormHelperTextProps;

export const UiFormHelperText = FormHelperText;
